import React from "react";
import {
  IsAllow,
  ValidatePermission,
} from "../../utils/allowHelper/AllowHelper";
import PhoneNumberCommunicationModal from "../phoneNumberCommunicationModal/PhoneNumberCommunicationModal";
import EmailCommunicationModal from "../emailCommunicationModal.jsx/EmailCommunicationModal";
import { PERMISSION_CODE } from "../../utils/enum/enums";
import { useSelector } from "react-redux";
import { useGetUserByIdQuery } from "store/api/apiSlice";

const ClientsTable = ({
  clients,
  allow,
  categories,
  translate,
  onViewClient,
}) => {
  const { user } = useSelector((state) => state.user);
  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const getCategory = (categoryId) => {
    let category = categories.find((cat) => cat._id === categoryId);

    if (!category) {
      category = categories.find((cat) => cat._id === "0");
    }

    return category;
  };

  if (userLoading) return null;

  return (
    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
      <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        <tr>
          <th className="px-6 py-3">
            {IsAllow(allow, "customer-02")
              ? translate("shop-name")
              : translate("account-number")}
          </th>
          <th className="px-6 py-3">
            {IsAllow(allow, "customer-02")
              ? translate("contact-name")
              : translate("name")}
          </th>
          <th className="px-6 py-3">{translate("category")}</th>
          <th className="px-6 py-3">{translate("contact")}</th>
          <th className="px-6 py-3">
            <span className="sr-only">{translate("edit")}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {clients.map((client) => (
          <tr
            key={client._id}
            className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
          >
            <td className="px-6 py-4 font-medium text-gray-900 dark:text-white">
              {IsAllow(allow, "customer-02")
                ? client.shopName
                : client.accountNumber}
            </td>
            <td className="px-6 py-4 font-medium text-gray-900 dark:text-white">
              {IsAllow(allow, "customer-02")
                ? client.contactName
                : client.fullName}
            </td>
            <td className="px-6 py-4">
              {getCategory(client.categoryId)?.name}
            </td>
            <td className="px-6 py-4">
              <div className="flex flex-col">
                {client.phoneNumber && (
                  <div className="flex items-center">
                    {IsAllow(allow, "whatsapp") ||
                    IsAllow(allow, "call") ||
                    IsAllow(allow, "msg") ? (
                      <PhoneNumberCommunicationModal
                        key={`phone-${client._id}`}
                        customer={client}
                        disabled={
                          getCategory(client.categoryId)
                            ?.isDisabledPhoneNumber ||
                          (!ValidatePermission(userProfile?.user, [
                            PERMISSION_CODE.DO_CALLS,
                          ]) &&
                            !ValidatePermission(userProfile?.user, [
                              PERMISSION_CODE.SEND_SMS,
                            ]))
                        }
                      />
                    ) : (
                      <>{client.phoneNumber}</>
                    )}
                    {client.extPhoneNumber && client.extPhoneNumber !== "-" && (
                      <span className="ml-1 text-gray-500">
                        ({translate("extension")}: {client.extPhoneNumber})
                      </span>
                    )}
                  </div>
                )}

                {client.email &&
                  (IsAllow(allow, "email") ? (
                    <EmailCommunicationModal
                      key={`email-${client._id}`}
                      customer={client}
                      disabled={
                        getCategory(client.categoryId)?.isDisabledEmail ||
                        !ValidatePermission(userProfile?.user, [
                          PERMISSION_CODE.SEND_EMAILS,
                        ])
                      }
                    />
                  ) : (
                    <>{client.email}</>
                  ))}
              </div>
            </td>
            <td className="px-6 py-4 text-right">
              <button
                onClick={() => onViewClient(client._id)}
                className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
              >
                {translate("view")}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ClientsTable;
